import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[om-card-svg]',
})
export class SmallCardSvgDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
